<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M17.46 15.7C13.56 13.3 11.1 7.99 10 5.03A4.43 4.43 0 0 0 5.85 2.2a.85.85 0 0 0-.57 1.5c1.1.98 1.31 2.38 1.6 4.32.34 2.32.77 5.2 2.9 8.75.12.22.34.37.59.4l3.51.59v3.2c0 .48.39.86.86.86h3.4c.48 0 .86-.38.86-.86v-2.54c0-1.11-.57-2.12-1.54-2.71Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
